var map = {
	"./account-service/WhatsApp.webp": 7157,
	"./account-service/telegram.webp": 448,
	"./fm.webp": 7104,
	"./resources.webp": 8914,
	"./service.webp": 3864,
	"./team.webp": 768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6398;